// extracted by mini-css-extract-plugin
export default {"root":"ManageDepartmentStaff_root__VLAIe","button":"ManageDepartmentStaff_button__EmnRK","staffs":"ManageDepartmentStaff_staffs__fIc+3"};